import '../scss/style.scss';

import { initStickyHeader } from './composables/stickyHeader';
import { initNavigation } from './composables/navigation';
import { initSlider } from './composables/slider';
import { initSlideshow } from './composables/slideshow';
import { initGallery } from './composables/gallery';

initStickyHeader();

document.addEventListener('DOMContentLoaded', () => {
    initNavigation();
    initSlider();
    initSlideshow();
    initGallery();
});
